import type { BetWonNotifyEvent } from './userNotify';

const CURRENCY_SYMBOLS: Record<string, string> = {
  GBP: '£',
  USD: '$',
  EUR: '€',
  AUD: 'A$',
  CAD: 'C$',
};

export function currencySymbol(currency: string): string {
  return CURRENCY_SYMBOLS[currency.toUpperCase()] ?? currency;
}

export function formatProfit(amount: number, currency: string): string {
  const sym = currencySymbol(currency);
  const sign = amount >= 0 ? '+' : '-';
  return `${sign}${sym}${Math.abs(amount).toFixed(2)}`;
}

export function betWonTitle(): string {
  return 'Bet Won';
}

/** Horse name and course only (no profit). */
export function betWonHorseLine(event: BetWonNotifyEvent): string {
  const place = event.course ? ` at ${event.course}` : '';
  return `${event.horseName}${place}`;
}

/** Web Push body: horse/course, then profit on the next line. */
export function betWonPushBody(event: BetWonNotifyEvent): string {
  return `${betWonHorseLine(event)}\n${formatProfit(event.profit, event.currency)}`;
}
